if (!customElements.get('accessory-upsell-modal')) {
  customElements.define(
    'accessory-upsell-modal',
    class AccessoryUpsellModal extends HTMLElement {
      constructor() {
        super();

        this.dialog = this.querySelector('.accessory-upsell-modal__dialog');

        this.querySelector('.accessory-upsell-modal__backdrop').addEventListener('click', this.close.bind(this));
        this.querySelector('.accessory-upsell-modal__close').addEventListener('click', this.close.bind(this));
        this.querySelector('.accessory-upsell-modal__skip').addEventListener('click', this.close.bind(this));
        this.querySelector('.accessory-upsell-modal__keep-shopping').addEventListener('click', this.close.bind(this));
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.addEventListener('click', this.handleVariantClick.bind(this));
        this.addEventListener('click', this.handleAddClick.bind(this));

        subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
          if (window.__dibsUpsellHandled) return;
          if (data?.cartData?.product_type === 'Paddle') {
            setTimeout(() => this.open(), 350);
          }
        });
      }

      open() {
        // Speed: accessory images are only fetched the first time the modal opens.
        this.querySelectorAll('img[data-src]').forEach((img) => {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        });
        this.classList.add('active');
        this.classList.remove('has-added-item');
        this.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        this.dialog.focus();
        trapFocus(this.dialog);
      }

      close() {
        this.classList.remove('active');
        this.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        removeTrapFocus();
        this.dispatchEvent(new CustomEvent('accessory-upsell:closed', { bubbles: true }));
      }

      handleVariantClick(evt) {
        const option = evt.target.closest('.accessory-upsell-modal__variant-option');
        if (!option) return;

        const item = option.closest('.accessory-upsell-modal__item');
        item.querySelectorAll('.accessory-upsell-modal__variant-option').forEach((el) => {
          el.classList.toggle('is-selected', el === option);
        });

        const addButton = item.querySelector('.accessory-upsell-modal__add');
        if (addButton) addButton.dataset.variantId = option.dataset.variantId;

        const image = item.querySelector('.accessory-upsell-modal__item-image');
        if (image && option.dataset.imageUrl) image.src = option.dataset.imageUrl;
      }

      handleAddClick(evt) {
        const button = evt.target.closest('.accessory-upsell-modal__add');
        if (!button || button.classList.contains('is-added') || button.getAttribute('aria-disabled') === 'true')
          return;

        button.setAttribute('aria-disabled', 'true');

        const body = JSON.stringify({
          id: button.dataset.variantId,
          quantity: 1,
          sections: ['cart-notification-product', 'cart-notification-button', 'cart-notification-shipping', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              button.removeAttribute('aria-disabled');
              return;
            }
            button.classList.add('is-added');
            this.classList.add('has-added-item');
            const cartNotification = document.querySelector('cart-notification');
            if (cartNotification) cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
            button.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
